import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CreateDealBannerManagementSlice } from "../../../redux/features/BannerManagementSlice";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { onImageHandler } from "../../../components/UploadImageOnBucket";

const AddDealsBanner = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dealBannerRef = useRef();

  const [data, setData] = useState({
    dealbannerTitle: "",
    dealbannerImage: "",
  });

  const {loading} = useSelector((state)=>state.bannerManagement)

  const [isUploading, setIsUploading] = useState(false); // Track image upload

  const handleImage = async (e) => {
    setIsUploading(true); 
    try {
      const uploadedData = await onImageHandler(e);
      setData((prev) => ({
        ...prev,
        dealbannerImage: uploadedData[1]?.location,
      }));
    } catch (error) {
      toast.error("Image upload failed!");
    } finally {
      setIsUploading(false); 
    }
  };

  useEffect(()=>setIsUploading(loading),[loading]);

  const handleSubmit = () => {
    if (
      !Object.entries(data)
        .map(([key, value]) => value?.trim()?.length)
        .every((item) => item > 0)
    ) {
      toast.error("Please fill the details!");
      return;
    }

    const formData = new FormData();
    formData.append("dealbannerTitle", data?.dealbannerTitle);
    formData.append("dealbannerImage", data?.dealbannerImage);
    dispatch(CreateDealBannerManagementSlice(formData)).then((res) => {
      dealBannerRef.current.click();
    });
  };

  return (
    <>
      <div className="ModalBox">
        <div
          id="DealsBannerAdd"
          className="modal fade"
          aria-hidden="true"
          data-backdrop="static"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="Category">
                  <a
                    href="javascript:void(0);"
                    className="CloseModal"
                    data-dismiss="modal"
                    ref={dealBannerRef}
                    onClick={() => navigate(-1)}
                  >
                    ×
                  </a>
                  <h3>Add Banner</h3>
                  <div className="form-group">
                    <label>Deals Banner Title</label>
                    <select name="" id="" className="form-control" onChange={(e) =>
                        setData((prev) => ({
                          ...prev,
                          dealbannerTitle: e.target.value,
                        }))
                      }>
                      <option value="Birthday Decoration">Birthday Decoration</option>
                      <option value="Anniversary Decoration">Anniversary Decoration</option>
                      <option value="Kids Party">Kids Party</option>
                      <option value="Baby Shower">Baby Shower</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Upload Deal Banner Image</label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={handleImage}
                      disabled={isUploading}
                    />
                    {isUploading && <p>Uploading image...</p>}
                  </div>
                  <button
                    className="Button"
                    onClick={handleSubmit}
                    disabled={isUploading || !data.dealbannerImage} // Disable until image is uploaded
                  >
                    {isUploading ? "Please wait..." : "Add"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddDealsBanner;
